// Eigen types voor de control-API's. De waarden zijn gelijk aan die van Material, zodat de
// controls ze ongewijzigd kunnen doorgeven; consumers zien zo nergens een Material-type en een
// overstap naar een ander UI-package raakt alleen de control-templates.

export const fieldAppearance = {
    fill: 'fill',
    outline: 'outline',
} as const;

export type TFieldAppearance = (typeof fieldAppearance)[keyof typeof fieldAppearance];

export const fieldColor = {
    primary: 'primary',
    accent: 'accent',
    warn: 'warn',
} as const;

export type TFieldColor = (typeof fieldColor)[keyof typeof fieldColor] | undefined;

export const floatLabel = {
    always: 'always',
    auto: 'auto',
} as const;

export type TFloatLabel = (typeof floatLabel)[keyof typeof floatLabel];

export const hintAlign = {
    start: 'start',
    end: 'end',
} as const;

export type THintAlign = (typeof hintAlign)[keyof typeof hintAlign];

export const labelPosition = {
    before: 'before',
    after: 'after',
} as const;

export type TLabelPosition = (typeof labelPosition)[keyof typeof labelPosition];

export const subscriptSizing = {
    fixed: 'fixed',
    dynamic: 'dynamic',
} as const;

export type TSubscriptSizing = (typeof subscriptSizing)[keyof typeof subscriptSizing];

export const toggleAppearance = {
    standard: 'standard',
    legacy: 'legacy',
} as const;

export type TToggleAppearance = (typeof toggleAppearance)[keyof typeof toggleAppearance];

// Sorteerfunctie voor de opties van een select, op de waarden zelf (geen Material-optie-object).
export type TOptionSortComparator = (a: unknown, b: unknown) => number;
